import { TinyColor } from '@ctrl/tinycolor';
import { colorBgMask, colorWhite, colorDuxtonBlue, colorNeutral } from '@duxton-web/design-tokens'; // Dui
export default function genColorMapToken(seed, _ref) {
  let {
    generateColorPalettes,
    generateNeutralColorPalettes
  } = _ref;
  const {
    colorSuccess: colorSuccessBase,
    colorWarning: colorWarningBase,
    colorError: colorErrorBase,
    colorInfo: colorInfoBase,
    colorPrimary: colorPrimaryBase,
    colorBgBase,
    colorTextBase
  } = seed;
  const primaryColors = generateColorPalettes(colorPrimaryBase);
  const successColors = generateColorPalettes(colorSuccessBase);
  const warningColors = generateColorPalettes(colorWarningBase);
  const errorColors = generateColorPalettes(colorErrorBase);
  const infoColors = generateColorPalettes(colorInfoBase);
  const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
  const neutralTypeColors = generateColorPalettes(colorNeutral); // Dui has neutral color variant
  const secondaryColors = generateColorPalettes(colorDuxtonBlue); // Dui has secondary color variant
  // Color Link
  const colorLink = seed.colorLink || seed.colorInfo;
  const linkColors = generateColorPalettes(colorLink);
  return Object.assign(Object.assign({}, neutralColors), {
    // Global token
    colorPrimaryBg: primaryColors[1],
    colorPrimaryBgHover: primaryColors[7],
    colorPrimaryBorder: primaryColors[3],
    colorPrimaryBorderHover: primaryColors[3],
    colorPrimaryHover: primaryColors[7],
    colorPrimary: primaryColors[6],
    colorPrimaryActive: primaryColors[9],
    colorPrimaryTextHover: primaryColors[9],
    colorPrimaryText: primaryColors[9],
    colorPrimaryTextActive: primaryColors[10],
    colorSuccessBg: successColors[1],
    colorSuccessBgHover: successColors[3],
    colorSuccessBorder: successColors[3],
    colorSuccessBorderHover: successColors[3],
    colorSuccessHover: successColors[3],
    colorSuccess: successColors[6],
    colorSuccessActive: successColors[3],
    colorSuccessTextHover: successColors[3],
    colorSuccessText: successColors[9],
    colorSuccessTextActive: successColors[3],
    colorErrorBg: errorColors[1],
    colorErrorBgHover: errorColors[8],
    colorErrorBorder: errorColors[3],
    colorErrorBorderHover: errorColors[8],
    colorErrorHover: errorColors[8],
    colorError: errorColors[7],
    colorErrorActive: errorColors[9],
    colorErrorTextHover: errorColors[3],
    colorErrorText: errorColors[9],
    colorErrorTextActive: errorColors[8],
    colorWarningBg: warningColors[1],
    colorWarningBgHover: warningColors[3],
    colorWarningBorder: warningColors[3],
    colorWarningBorderHover: warningColors[3],
    colorWarningHover: warningColors[3],
    colorWarning: warningColors[7],
    colorWarningActive: warningColors[3],
    colorWarningTextHover: warningColors[3],
    colorWarningText: warningColors[11],
    colorWarningTextActive: warningColors[3],
    colorInfoBg: infoColors[1],
    colorInfoBgHover: infoColors[3],
    colorInfoBorder: infoColors[3],
    colorInfoBorderHover: infoColors[3],
    colorInfoHover: infoColors[3],
    colorInfo: infoColors[7],
    colorInfoActive: infoColors[3],
    colorInfoTextHover: infoColors[3],
    colorInfoText: infoColors[9],
    colorInfoTextActive: infoColors[8],
    // Dui start
    colorNeutralBg: neutralTypeColors[1],
    colorNeutralBgHover: neutralTypeColors[3],
    colorNeutralBorder: neutralTypeColors[6],
    colorNeutralBorderHover: neutralTypeColors[3],
    colorNeutralHover: neutralTypeColors[3],
    colorNeutral: neutralTypeColors[7],
    colorNeutralActive: neutralTypeColors[9],
    colorNeutralTextHover: neutralTypeColors[3],
    colorNeutralText: neutralTypeColors[9],
    colorNeutralTextActive: neutralTypeColors[8],
    colorSecondaryBg: secondaryColors[1],
    colorSecondaryBgHover: secondaryColors[3],
    colorSecondaryBorder: secondaryColors[7],
    colorSecondaryBorderHover: secondaryColors[7],
    colorSecondaryHover: secondaryColors[3],
    colorSecondary: secondaryColors[1],
    colorSecondaryActive: secondaryColors[6],
    colorSecondaryTextHover: primaryColors[9],
    colorSecondaryText: secondaryColors[9],
    colorSecondaryTextActive: primaryColors[10],
    colorTertiaryBg: secondaryColors[1],
    colorTertiaryBgHover: secondaryColors[1],
    colorTertiaryBorder: secondaryColors[7],
    colorTertiaryBorderHover: secondaryColors[7],
    colorTertiaryHover: secondaryColors[7],
    colorTertiary: secondaryColors[6],
    colorTertiaryActive: secondaryColors[3],
    colorTertiaryTextHover: secondaryColors[9],
    colorTertiaryText: secondaryColors[9],
    colorTertiaryTextActive: secondaryColors[9],
    // Dui end
    colorLinkHover: linkColors[8],
    colorLink: linkColors[7],
    colorLinkActive: linkColors[8],
    colorBgMask: new TinyColor(colorBgMask).setAlpha(0.45).toRgbString(),
    colorWhite
  });
}